'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('piperGuestEdit', {
      url: '/piper/guest/edit/:id',
      template: '<piper-guest-edit></piper-guest-edit>'
    });
}



// WEBPACK FOOTER //
// ./client/app/piper/guest/edit/guest-edit.routes.js